import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '@/store'
import ability from '@/libs/acl/ability'

import { isUserLoggedIn, silentLogin, } from '@/auth/utils'
import { canNavigate as canUserNavigate } from '@/libs/acl/routeProtection'

import utils from './routes/utils'
import authentication from './routes/authentication'

import users from './routes/apps/users'
import measurement from './routes/apps/measurement'
import report from './routes/apps/report'

import user_permission from './routes/apps/user_permission'
import railway_structure from './routes/apps/railway_structure/'
import documentation from './routes/apps/documentation'



Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
      { path: '/', redirect: { name: 'railway_structure-railway-list' } },
      ...utils,
      ...authentication,

      ...users,
      ...measurement,
      ...report,
      ...user_permission,
      ...railway_structure,
      ...documentation,

      {
          path: '*',
          redirect: 'error-404',
      },
  ],
})


router.beforeEach(  async (to, _, next) => {

    let isLoggedIn = isUserLoggedIn()
    let canNavigate = canUserNavigate(to)


    // all the time re-auth if user doesnt logs in
    if (!isLoggedIn) {
        await silentLogin().catch((err)=>{})
        isLoggedIn = isUserLoggedIn()
        if (isLoggedIn)
            await store.dispatch('auth/fetchUser').catch((err)=>{})
    }

    // check initial canNavigate
    if (canNavigate) {

        // handle authentication pages, try to and go futher
        if (to.meta.redirectIfLoggedIn){
            if (!canUserNavigate(router.resolve({ path: '/'}).resolved)) {
                if (isLoggedIn) return next({ name: 'misc-no-permission'})
            } else {
                return next({ path: '/'})
            }
        }

    } else {
        if (!canUserNavigate(to)){
            if (isLoggedIn)
                return next({ name: 'misc-no-permission'})

            return next({ name: 'misc-not-authorized'})
        }
    }
    return next()
})


// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {

  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
